import { QueryClient } from '@tanstack/react-query';
import { shouldRetryQuery } from './queryRetry';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetryQuery,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});
